import { render, staticRenderFns } from "./disbursement-list.vue?vue&type=template&id=18c960f8&"
import script from "./disbursement-list.vue?vue&type=script&lang=js&"
export * from "./disbursement-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports